export default {
  SET_ACCOUNT_LIST_DATA(state, params) {
    state.listGridData = params;
  },
  SET_ACCOUNT_CHANGES_DATA(state, params) {
    state.changesGridData = params;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/accountManagement/accountReport/accountReportMutation.js